export const environment = {
  production: false,
  apiUrl: 'https://dev-api.rockspoon.io',
  authenticationPortalUrl: 'https://dev-accounts-xoxpy7buypffrsdqstc7.rockspoon.io',
  client: 'REGP',
  endOfTheFlowUrl: 'https://rockspoon.youcanbook.me/?BUSINESSENTITYID=',
  env: 'dev'
};
